import { forwardRef, useEffect, useState } from "react";
import { Section } from "../components/Layout/Section";
import { Container } from "../components/Layout/Container";
import styled from "@emotion/styled";
import { Divider } from "../components/Layout/Divider";
import { useApp } from "../AppProvider";
import { getDocs } from "@firebase/firestore";
import { collection } from "@firebase/firestore";
import Job from "../components/Jobs/Job";
import SectionTitle from "../components/SectionTitle";

const Text = styled("p")(() => ({
  fontSize: "2rem",
  fontWeight: 400,
  letterSpacing: -2,
  margin: "0 0 2rem 0",
  "@media (min-width: 768px)": {
    fontSize: "3rem",
  },
}));

const JobButton = styled("button")(() => ({
  border: "none",
  cursor: "pointer",
  padding: "8px 16px",
  borderRadius: 4,
  backgroundColor: "#000",
  color: "#fff",
  textDecoration: "none",
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: -0.5,
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#333",
  },
}));

const SmallText = styled("p")(() => ({
  fontSize: "1.5rem",
  fontWeight: 400,
  letterSpacing: -2,
  margin: 0,
  "@media (min-width: 768px)": {
    fontSize: "2rem",
  },
}));

const JobList = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  "@media (min-width: 768px)": {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "2rem",
  },
  "@media (min-width: 1024px)": {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  "@media (min-width: 1280px)": {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
}));

type JobType = {
  id: string;
  title: string;
  description: string;
};

type Props = {
  handleKontaktformular: () => void;
};

export const Jobs = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const [jobs, setJobs] = useState<JobType[]>([]);
  const { cookiesAccepted, db } = useApp();

  useEffect(() => {
    let cancel = false;

    if (cookiesAccepted === undefined || !db) {
      return;
    }

    getDocs(collection(db, "jobs"))
      .then((querySnapshot) => {
        const newJobs: JobType[] = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data() as JobType;
          data.id = doc.id;
          newJobs.push(data);
        });
        if (!cancel) {
          setJobs(newJobs);
        }
      })
      .catch((error) => console.log(error.message));

    return () => {
      cancel = true;
    };
  }, [cookiesAccepted, db]);

  return (
    <Section ref={ref} id={"jobs"}>
      <Container>
        <SectionTitle>JOBS</SectionTitle>
        <Text>
          Ihr habt Bock, mit einem kreativen und coolen Team in der
          Filmproduktion oder Fotoproduktion zu arbeiten?
        </Text>
        <SmallText>
          Mit abwechslungsreichen nationalen und internationalen Projekten? Dann
          schaut immer wieder mal hier drauf….denn vielleicht suchen wir genau
          Dich!
        </SmallText>
        <div style={{ marginTop: 20, display: "flex", flexDirection: "row" }}>
          <JobButton type={"button"} onClick={props.handleKontaktformular}>
            Jetzt bewerben!
          </JobButton>
        </div>
        <Divider />
        {jobs.length > 0 && <p>Diese Stellen suchen wir:</p>}
        {jobs.length <= 0 && (
          <p>
            Leider sind aktuell keine Jobangebote ausgeschrieben, wir freuen uns
            dennoch über deine Initiativanfrage!
          </p>
        )}
        <JobList>
          {jobs.map((job) => (
            <Job {...job} key={job.id} />
          ))}
        </JobList>
      </Container>
    </Section>
  );
});
